export default [
    /*HoangTM - Công khai tài chính*/
    {
        path: "budgetreport",
        name: "Công khai tài chính",
        redirect: "budgetreport/list",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Quản lý nội dung công khai",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/List"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Quản lý nội dung công khai"
                },
            },
            {
                path: "viewer",
                name: "Hiển thị nội dung công khai",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/ReportViewer"
                    ),
                meta: {
                    requiresAuth: false,
                    title: "Hiển thị nội dung công khai"
                },
            },
            {
                path: "summary",
                name: "Thống kê báo cáo",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/ReportSummary"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thống kê BC công khai ngân sách"
                },
            },
            {
                path: "createbudget",
                name: "Thêm báo cáo công khai ngân sách",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/CreateBudget"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm BC công khai ngân sách"
                },
            },
            {
                path: "editbudget/:id",
                name: "Sửa thông tin báo cáo công khai ngân sách",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/EditBudget"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa BC công khai ngân sách"
                },
            },
            {
                path: "detailbudget/:id",
                name: "Thông tin chi tiết báo cáo công khai ngân sách",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/DetailBudget"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thông tin chi tiết báo cáo công khai ngân sách"
                },
            },
            {
                path: "create",
                name: "Thêm báo cáo khác",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/Create"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm báo cáo khác"
                },
            },
            {
                path: "edit/:id",
                name: "Sửa thông tin báo cáo khác",
                component: () =>
                    import(
                        "@/views/screens/budgetreport/Edit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa thông tin báo cáo khác"
                },
            },
        ],
    },
    /*End*/
]